// extracted by mini-css-extract-plugin
module.exports = {"cameraFace":"TwoDOverlayCameraItem_cameraFace__37UCe","nameHolder":"TwoDOverlayCameraItem_nameHolder__Hkzij","cameraFeedHolder":"TwoDOverlayCameraItem_cameraFeedHolder__26Rje"};